import { z } from 'zod/v4';
import { on } from 'events';
import { router, protectedProcedure, getContextDeps } from '../trpc';
import { ScopeName } from '../scopes';
import { serverEvents } from '../events';
import Logger from '@/logger';
import { parseLinks, sanitize } from '@util/chat';

export const chatRouter = router({
  chat: router({
    send: protectedProcedure(ScopeName.ChatSend)
      .input(z.string())
      .mutation(async ({ input: message, ctx }) => {
        const { database, omegga } = getContextDeps();

        if (typeof message !== 'string') return;
        if (message.length > 140) message = message.slice(0, 140);

        const user = {
          name: ctx.user.username || 'Admin',
          id: ctx.user.playerId,
          color: 'ff00ff',
          web: true,
        };

        const chatLog = await database.addChatLog('msg', user, message);
        serverEvents.emit('chat', chatLog);

        omegga.broadcast(
          `"[<b><color=\\"ff00ff\\">${user.name}</></>]: ${parseLinks(sanitize(message))}"`,
        );
        Logger.log(`[${user.name.brightMagenta.underline}]: ${message}`);

        return 'ok';
      }),

    recent: protectedProcedure(ScopeName.ChatRecent).query(() => {
      const { database } = getContextDeps();
      return database.getChats({ sameServer: true });
    }),

    history: protectedProcedure(ScopeName.ChatHistory)
      .input(
        z.object({
          after: z.number().optional(),
          before: z.number().optional(),
        }),
      )
      .query(({ input }) => {
        const { database } = getContextDeps();
        return database.getChats({ after: input.after, before: input.before });
      }),

    search: protectedProcedure(ScopeName.ChatHistory)
      .input(
        z.object({
          query: z.string().max(256),
          // `created` of the last entry on the previous page
          cursor: z.number().optional(),
          sort: z.enum(['newest', 'oldest']).optional(),
        }),
      )
      .query(({ input }) => {
        const { database } = getContextDeps();
        return database.searchChats(input);
      }),

    context: protectedProcedure(ScopeName.ChatHistory)
      .input(
        z.object({
          id: z.number(),
          direction: z.enum(['before', 'after']),
          count: z.number().min(1).max(25).optional(),
        }),
      )
      .query(({ input }) => {
        const { database } = getContextDeps();
        return database.getChatContext(input);
      }),

    calendar: protectedProcedure(ScopeName.ChatCalendar).query(() => {
      const { database } = getContextDeps();
      return database.calendar.years;
    }),

    onMessage: protectedProcedure(ScopeName.ChatRecent).subscription(
      async function* ({ signal, ctx }) {
        const combined = AbortSignal.any([signal!, ctx.userAbort().signal]);
        for await (const [chatLog] of on(serverEvents, 'chat', {
          signal: combined,
        })) {
          yield chatLog;
        }
      },
    ),
  }),
});
